export default "__VITE_PUBLIC_ASSET__de1a0e52__"